import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsys.myprofile.deduction');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsys-myprofile-deduction',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsys.myprofile.deduction/view.scss */
/* src/app/portal.lpsys.myprofile.deduction/view.scss: no such file or directory */`],
})
export class PortalLpsysMyprofileDeductionComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public tab: string = 'notice';

    // 소득공제 데이터
    public data: any = [];
    public saving: boolean = false;
    public submittingPeriod: boolean = false;

    // 시기변경 신청 진행상황 (LP)
    public periodChangeRequests: any[] = [];
    public signedUploadingId: string = '';
    public cancellingId: string = '';
    // 소득공제 산정 데이터
    public funds: any = [];
    public rows: any = [];
    public calcResult: any = [];
    public totalDeduction: number = 0;
    public totalCalcAmount: number = 0;
    public allSelected: boolean = false;
    public markUsedSaving: boolean = false;
    public downloadingDocs: boolean = false;

    // 사용처리 직후 스냅샷 (loadCalc로 사라지기 전 상태 보존 → 서류 다운로드용)
    public processedSnapshot: any[] = [];
    public processedTotalCalc: number = 0;
    public processedTotalDeduction: number = 0;

    // 과거 저장이력
    public calcHistory: any[] = [];
    public selectedHistory: any = null;
    public historyLoading: boolean = false;
    public historyDetailLoading: boolean = false;
    public historyDeletingId: string = '';

    // 공지사항 데이터
    public isAdmin: boolean = false;
    public notices: any[] = [];
    public selectedNotice: any = null;
    public editingNotice: any = null;
    public uploading: boolean = false;
    public savingNotice: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.isAdmin = ['admin', 'super_admin'].includes(this.service.auth.session?.membership);
        await this.loadNotices();
        await this.load();
        await this.loadCalc();
        await this.loadPeriodChangeRequests();
        await this.loadCalcHistory();
    }

    // ---------------- 시기변경 신청 진행상황 ----------------
    public async loadPeriodChangeRequests() {
        const { code, data } = await wiz.call("my_period_changes");
        if (code !== 200) return;
        this.periodChangeRequests = data?.rows || [];
        await this.service.render();
    }

    public periodStatusBadgeClass(s: string): string {
        const base = 'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium';
        if (s === 'requested') return `${base} bg-amber-100 text-amber-800`;
        if (s === 'form_sent') return `${base} bg-blue-100 text-blue-800`;
        if (s === 'signed_received') return `${base} bg-indigo-100 text-indigo-800`;
        if (s === 'completed') return `${base} bg-emerald-100 text-emerald-800`;
        if (s === 'cancelled') return `${base} bg-rose-100 text-rose-700`;
        return `${base} bg-zinc-100 text-zinc-700`;
    }

    public async uploadSignedForm(req: any) {
        if (this.signedUploadingId) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        this.signedUploadingId = req.id;
        await this.service.render();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const res: any = await this.service.file.upload('/file/upload', fd);
            const { code, data } = await wiz.call("upload_signed_form", {
                id: req.id,
                signed_form: res.url
            });
            if (code !== 200) {
                await this.service.alert.error(data?.message || "업로드 실패");
                return;
            }
            await this.service.alert.success("서명본이 접수되었습니다.");
            await this.loadPeriodChangeRequests();
        } finally {
            this.signedUploadingId = '';
            await this.service.render();
        }
    }

    public async cancelPeriodChange(req: any) {
        if (this.cancellingId) return;
        const ok = await this.service.alert.show({
            title: "시기변경 신청 취소",
            message: `${req.fund_name} · ${req.company_name} (${req.prev_year}년 → ${req.requested_year}년) 시기변경 신청을 취소합니다. 진행하시겠습니까?`,
            action: '신청 취소',
            cancel: '닫기',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.cancellingId = req.id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("cancel_period_change", { id: req.id });
            if (code !== 200) {
                await this.service.alert.error(data?.message || "취소에 실패했습니다.");
                return;
            }
            await this.service.alert.success("시기변경 신청이 취소되었습니다.");
            await this.load();
            await this.loadCalc();
            await this.loadPeriodChangeRequests();
        } finally {
            this.cancellingId = '';
            await this.service.render();
        }
    }

    // ---------------- 탭 ----------------
    public async setTab(tab: string) {
        this.tab = tab;
        this.selectedNotice = null;
        this.editingNotice = null;
        await this.service.render();
    }

    public tabClass(tab: string): string {
        const base = 'whitespace-nowrap border-b-2 px-1 pb-3 text-[13px] font-medium cursor-pointer transition-colors';
        if (this.tab === tab) {
            return `${base} border-blue-600 text-blue-600`;
        }
        return `${base} border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300`;
    }

    // ---------------- 공지사항 ----------------
    public async loadNotices() {
        const { code, data } = await wiz.call("notice_list");
        if (code !== 200) return;
        this.notices = (data && data.rows) ? data.rows : [];
        await this.service.render();
    }

    public async openNotice(notice: any) {
        const { code, data } = await wiz.call("notice_get", { id: notice.id });
        if (code !== 200) {
            await this.service.alert.error("공지사항을 불러오지 못했습니다.");
            return;
        }
        this.selectedNotice = data;
        this.editingNotice = null;
        await this.service.render();
    }

    public async closeNotice() {
        this.selectedNotice = null;
        this.editingNotice = null;
        await this.service.render();
    }

    public async newNotice() {
        if (!this.isAdmin) return;
        this.editingNotice = {
            id: '',
            title: '',
            content: '',
            is_published: 1,
            attachments: []
        };
        this.selectedNotice = null;
        await this.service.render();
    }

    public async editNotice(notice: any) {
        if (!this.isAdmin) return;
        const { code, data } = await wiz.call("notice_get", { id: notice.id });
        if (code !== 200) {
            await this.service.alert.error("공지사항을 불러오지 못했습니다.");
            return;
        }
        this.editingNotice = JSON.parse(JSON.stringify(data));
        if (!this.editingNotice.attachments) this.editingNotice.attachments = [];
        this.selectedNotice = null;
        await this.service.render();
    }

    public async cancelEdit() {
        this.editingNotice = null;
        await this.service.render();
    }

    public async uploadAttachment() {
        if (!this.editingNotice) return;
        let files = await this.service.file.select();
        if (files.length === 0) return;

        this.uploading = true;
        await this.service.render();
        try {
            for (let i = 0; i < files.length; i++) {
                let fd = new FormData();
                fd.append('upload', files[i]);
                let fdurl = '/file/upload?mode=deduction-notice';
                const { url } = await this.service.file.upload(fdurl, fd, async () => { });
                this.editingNotice.attachments.push({
                    name: files[i].name,
                    url: url,
                    size: files[i].size,
                    uploaded_at: new Date().toISOString()
                });
            }
        } catch (e) {
            await this.service.alert.error("파일 업로드에 실패했습니다.");
        }
        this.uploading = false;
        await this.service.render();
    }

    public async removeAttachment(idx: number) {
        if (!this.editingNotice) return;
        const ok = await this.service.alert.show({
            title: '첨부파일 삭제',
            message: '이 첨부파일을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.editingNotice.attachments.splice(idx, 1);
        await this.service.render();
    }

    public async saveNotice() {
        if (!this.editingNotice) return;
        if (!this.editingNotice.title || !this.editingNotice.title.trim()) {
            await this.service.alert.error("제목을 입력하세요.");
            return;
        }
        this.savingNotice = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("notice_save", {
                id: this.editingNotice.id || '',
                title: this.editingNotice.title,
                content: this.editingNotice.content || '',
                is_published: this.editingNotice.is_published ? 1 : 0,
                attachments: JSON.stringify(this.editingNotice.attachments || [])
            });
            if (code !== 200) {
                await this.service.alert.error("저장에 실패했습니다.");
                this.savingNotice = false;
                await this.service.render();
                return;
            }
            await this.service.alert.success("저장되었습니다.");
            this.editingNotice = null;
            await this.loadNotices();
        } catch (e) {
            await this.service.alert.error("저장 중 오류가 발생했습니다.");
        }
        this.savingNotice = false;
        await this.service.render();
    }

    public async deleteNotice(notice: any) {
        if (!this.isAdmin) return;
        const ok = await this.service.alert.show({
            title: '공지사항 삭제',
            message: '이 공지사항을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error'
        });
        if (!ok) return;
        const { code } = await wiz.call("notice_delete", { id: notice.id });
        if (code !== 200) {
            await this.service.alert.error("삭제에 실패했습니다.");
            return;
        }
        await this.service.alert.success("삭제되었습니다.");
        if (this.selectedNotice && this.selectedNotice.id === notice.id) this.selectedNotice = null;
        await this.loadNotices();
    }

    // ---------------- 소득공제 ----------------
    public async load() {
        const { code, data } = await wiz.call("list");
        if (code !== 200) return;

        data.sort((a, b) => {
            let ac = a.registered_date ? new Date(a.registered_date).getTime() : 0;
            let bc = b.registered_date ? new Date(b.registered_date).getTime() : 0;
            return bc - ac;
        });

        let rows = [];
        for (let fund of data) {
            if (!fund.member.extra) fund.member.extra = {};
            if (!fund.member.extra.deduction) fund.member.extra.deduction = {};

            let investments = fund.investment || [];
            if (investments.length === 0) {
                rows.push({
                    fund: fund,
                    investment: null,
                    deduction: null,
                    _rowspan: 1,
                    _first: true
                });
            } else {
                for (let i = 0; i < investments.length; i++) {
                    let invest = investments[i];
                    let ded = fund.member.extra.deduction[invest.id];
                    if (!ded) {
                        ded = { year_override: '', used: false, docs: [] };
                        fund.member.extra.deduction[invest.id] = ded;
                    }
                    if (ded.used === undefined || ded.used === null) ded.used = false;
                    if (!ded.year_override) ded.year_override = '';
                    if (!ded.docs) ded.docs = [];

                    rows.push({
                        fund: fund,
                        investment: invest,
                        deduction: ded,
                        _baselineYear: ded.year_override || '',
                        _rowspan: i === 0 ? investments.length : 0,
                        _first: i === 0
                    });
                }
            }
        }

        this.data = rows;
        await this.service.render();
    }

    public defaultYear(item: any): string {
        // 기본 소득공제 연도는 폀드(조합) 단위로 통일 — 연도 재설정(year_override)이 있으면 그 값 우선.
        if (item?.deduction?.year_override) {
            return String(item.deduction.year_override);
        }
        if (item?.fund?.registered_date) {
            return String(item.fund.registered_date).substring(0, 4);
        }
        return '-';
    }

    public yearOptions(item: any = null): string[] {
        // 시기변경 옵션은 펀드(조합) 결성연도 기준 +1, +2년만 노출 (총 3개년 중 기본 외 2개).
        // 예) 결성연도가 2024면 2025, 2026 선택 가능.
        let baseYear: number = NaN;
        const reg = item?.fund?.registered_date;
        if (reg) {
            const y = parseInt(String(reg).substring(0, 4), 10);
            if (!isNaN(y)) baseYear = y;
        }
        if (isNaN(baseYear)) baseYear = new Date().getFullYear();
        return [String(baseYear + 1), String(baseYear + 2)];
    }

    public async toggleUsed(item: any) {
        item.deduction.used = !item.deduction.used;
        await this.save(item.fund);
        await this.loadCalc();
    }

    public async onYearOverrideChange(item: any) {
        // 즉시 저장하지 않고 in-memory만 업데이트.
        // "시기변경 저장" 버튼을 눌러야 DB 저장 + 관리자 알림 발송됨.
        // (펀드 단위 자동 전파는 더 이상 수행하지 않음 — 투자건별로 개별 변경/신청)
        await this.service.render();
    }

    public hasPendingPeriodChanges(): boolean {
        for (let item of this.data) {
            if (!item.investment || !item.deduction) continue;
            if (item.deduction.used) continue;
            const cur = item.deduction.year_override || '';
            const base = item._baselineYear || '';
            if (cur !== base) return true;
        }
        return false;
    }

    public pendingPeriodChangeCount(): number {
        let n = 0;
        for (let item of this.data) {
            if (!item.investment || !item.deduction) continue;
            if (item.deduction.used) continue;
            const cur = item.deduction.year_override || '';
            const base = item._baselineYear || '';
            if (cur !== base) n++;
        }
        return n;
    }

    public async submitPeriodChange() {
        if (this.submittingPeriod) return;

        // 변경 건 수집
        const changes: any[] = [];
        const fundDeductions: any = {};
        for (let item of this.data) {
            if (!item.investment || !item.deduction) continue;
            if (item.deduction.used) continue;
            const cur = item.deduction.year_override || '';
            const base = item._baselineYear || '';
            if (cur === base) continue;
            const baseYear = item.fund?.registered_date
                ? String(item.fund.registered_date).substring(0, 4) : '';
            changes.push({
                fund_id: item.fund.id,
                fund_name: item.fund?.name || '',
                investment_id: item.investment.id,
                company_name: item.investment?.company_name || '',
                year: cur || baseYear,
                base_year: baseYear,
                prev_year: base || baseYear
            });
        }

        if (changes.length === 0) {
            await this.service.alert.error("변경된 시기가 없습니다.");
            return;
        }

        const ok = await this.service.alert.show({
            title: "시기변경 저장",
            message: `총 ${changes.length}건의 시기변경을 저장하고 관리자에게 신청 알림을 발송합니다. 진행하시겠습니까?`,
            action: '저장 및 신청',
            cancel: '취소',
            actionBtn: 'info'
        });
        if (!ok) return;

        // 펀드별 deduction 전체를 묶어서 저장 (투자건 외 다른 항목 보존)
        for (let item of this.data) {
            if (!item.fund || !item.investment) continue;
            const fid = item.fund.id;
            if (!fundDeductions[fid]) {
                fundDeductions[fid] = item.fund.member?.extra?.deduction || {};
            }
        }

        this.submittingPeriod = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("request_period_change", {
                changes: JSON.stringify(changes),
                deductions: JSON.stringify(fundDeductions)
            });
            if (code !== 200) {
                let msg = "시기변경 신청에 실패했습니다.";
                if (typeof data === 'string') msg = data;
                else if (data && typeof data === 'object' && data.message) msg = data.message;
                await this.service.alert.error(msg);
                this.submittingPeriod = false;
                await this.service.render();
                return;
            }
        } catch (e) {
            await this.service.alert.error("시기변경 신청에 실패했습니다.");
            this.submittingPeriod = false;
            await this.service.render();
            return;
        }
        this.submittingPeriod = false;
        await this.service.alert.success(`총 ${changes.length}건의 시기변경 신청이 접수되었습니다.`);
        // baseline을 최신값으로 갱신 (재조회 대신 빠른 처리)
        await this.load();
        await this.loadCalc();
        await this.loadPeriodChangeRequests();
    }

    public async save(fund: any) {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        try {
            const deduction = fund.member.extra.deduction || {};
            const { code } = await wiz.call("update", {
                fund_id: fund.id,
                deduction: JSON.stringify(deduction)
            });
            if (code != 200) {
                await this.service.alert.error("저장에 실패했습니다.");
            }
        } catch (e) {
            await this.service.alert.error("저장에 실패했습니다.");
        }
        this.saving = false;
        await this.service.render();
    }

    public contributionAmount(fund: any): number {
        return (fund.member.applied_amount || 0) * (fund.amount_per_share || 0);
    }

    public deductionLabel(item: any, file: any = null): string {
        let year = '';
        if (file?.year) {
            year = String(file.year);
        } else if (item?.deduction?.year_override) {
            year = String(item.deduction.year_override);
        } else if (item?.fund?.registered_date) {
            year = String(item.fund.registered_date).substring(0, 4);
        }
        let companyName = item?.investment?.company_name || '-';
        let memberName = this.service?.auth?.session?.name || '-';
        let fundName = item?.fund?.name || '-';
        let yearLabel = year ? `${year}년` : '-';
        return `${companyName} · ${yearLabel} · ${memberName} · ${fundName}`;
    }

    // ---------------- 소득공제 산정 ----------------
    public async loadCalc() {
        const { code, data } = await wiz.call("calc_load");
        if (code !== 200) return;

        data.sort((a, b) => {
            let ac = a.registered_date ? new Date(a.registered_date).getTime() : 0;
            let bc = b.registered_date ? new Date(b.registered_date).getTime() : 0;
            return bc - ac;
        });

        this.funds = data;

        let rows = [];
        for (let fund of data) {
            if (!fund.member.extra) fund.member.extra = {};
            if (!fund.member.extra.deduction) fund.member.extra.deduction = {};

            let investments = fund.investment || [];
            for (let invest of investments) {
                let ded = fund.member.extra.deduction[invest.id];
                let used = ded && ded.used === true;
                if (used) continue;

                let userContribution = (fund.member.applied_amount || 0) * (fund.amount_per_share || 0);
                let totalAmount = fund.total_amount || 0;
                let investmentAmount = invest.investment_amount || 0;

                let calcAmount = 0;
                if (totalAmount > 0) {
                    calcAmount = Math.floor(investmentAmount * userContribution / totalAmount);
                }

                rows.push({
                    fund: fund,
                    investment: invest,
                    calcAmount: calcAmount,
                    userContribution: userContribution,
                    selected: false
                });
            }
        }

        this.rows = rows;
        this.calculate();
        await this.service.render();
    }

    public async toggleSelect(row: any) {
        row.selected = !row.selected;
        this.calculate();
        await this.service.render();
    }

    public async toggleSelectAll() {
        let target = !this.allSelected;
        for (let row of this.rows) {
            row.selected = target;
        }
        this.calculate();
        await this.service.render();
    }

    public calculate() {
        let selected = this.rows.filter(r => r.selected);
        this.allSelected = this.rows.length > 0 && this.rows.every(r => r.selected);

        let cumulative = 0;
        this.calcResult = selected.map(row => {
            let prevCumulative = cumulative;
            cumulative += row.calcAmount;
            let deductionAmount = this.calcMarginalDeduction(prevCumulative, row.calcAmount);

            return {
                fund: row.fund,
                investment: row.investment,
                depositDate: row.fund.registered_date || '-',
                investType: '벤처 등',
                fundName: row.fund.name || '-',
                uniqueNumber: row.fund.unique_number || '-',
                account: row.fund.account || '-',
                calcAmount: row.calcAmount,
                deductionAmount: deductionAmount
            };
        });

        this.totalCalcAmount = cumulative;
        this.totalDeduction = this.calcResult.reduce((sum, r) => sum + r.deductionAmount, 0);
    }

    public async markSelectedAsUsed() {
        if (this.markUsedSaving) return;
        const selected = this.rows.filter(r => r.selected);
        if (selected.length === 0) {
            await this.service.alert.error("선택된 항목이 없습니다.");
            return;
        }
        const ok = await this.service.alert.show({
            title: '사용 처리 확정',
            message: `선택한 ${selected.length}건을 '사용'으로 표시하시겠습니까?\n[소득공제 관리] 탭에서 '사용' 상태로 변경됩니다.`,
            action: '사용 처리',
            actionBtn: 'primary'
        });
        if (!ok) return;

        const fundMap: any = {};
        for (let row of selected) {
            const fid = row.fund.id;
            if (!fundMap[fid]) {
                fundMap[fid] = row.fund;
                if (!fundMap[fid].member.extra) fundMap[fid].member.extra = {};
                if (!fundMap[fid].member.extra.deduction) fundMap[fid].member.extra.deduction = {};
            }
            const ded = fundMap[fid].member.extra.deduction[row.investment.id];
            if (!ded) {
                fundMap[fid].member.extra.deduction[row.investment.id] = { year_override: '', used: true, docs: [] };
            } else {
                ded.used = true;
            }
        }

        this.markUsedSaving = true;
        await this.service.render();
        try {
            for (const fid in fundMap) {
                const fund = fundMap[fid];
                const { code } = await wiz.call("update", {
                    fund_id: fund.id,
                    deduction: JSON.stringify(fund.member.extra.deduction)
                });
                if (code !== 200) {
                    await this.service.alert.error("저장에 실패했습니다.");
                    this.markUsedSaving = false;
                    await this.service.render();
                    return;
                }
            }
            // 사용처리 직전의 calcResult를 스냅샷으로 보존 → 사라지기 전 상태로 서류 다운로드 가능
            this.processedSnapshot = this.calcResult.map((r: any) => {
                const fundExtra = r.fund?.member?.extra || {};
                const dedInfo = (fundExtra.deduction || {})[r.investment.id] || {};
                const docs = (dedInfo.docs || []).slice();
                const incomeDocs = (fundExtra.income_doc || []).slice();
                return {
                    fund: r.fund,
                    investment: r.investment,
                    deduction: dedInfo,
                    fundName: r.fundName,
                    depositDate: r.depositDate,
                    investType: r.investType,
                    uniqueNumber: r.uniqueNumber,
                    account: r.account,
                    calcAmount: r.calcAmount,
                    deductionAmount: r.deductionAmount,
                    docs: docs,
                    incomeDocs: incomeDocs
                };
            });
            this.processedTotalCalc = this.totalCalcAmount;
            this.processedTotalDeduction = this.totalDeduction;

            // 과거 저장이력으로 영구 보존
            try {
                await wiz.call("save_calc_history", {
                    snapshot: JSON.stringify(this.processedSnapshot),
                    total_calc: String(this.processedTotalCalc),
                    total_deduction: String(this.processedTotalDeduction)
                });
                await this.loadCalcHistory();
            } catch (e) { }

            await this.service.alert.success(`${selected.length}건이 '사용' 상태로 변경되었습니다.\n아래 '처리 완료 항목' 영역에서 서류를 다운로드할 수 있습니다.`);
            await this.load();
            await this.loadCalc();
        } catch (e) {
            await this.service.alert.error("저장 중 오류가 발생했습니다.");
        }
        this.markUsedSaving = false;
        await this.service.render();
    }

    public clearProcessedSnapshot() {
        this.processedSnapshot = [];
        this.processedTotalCalc = 0;
        this.processedTotalDeduction = 0;
        this.service.render();
    }

    // ---------------- 과거 저장이력 ----------------
    public async loadCalcHistory() {
        this.historyLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("list_calc_history");
            if (code !== 200) return;
            this.calcHistory = data?.rows || [];
        } finally {
            this.historyLoading = false;
            await this.service.render();
        }
    }

    public async viewCalcHistory(item: any) {
        // 토글: 같은 항목 다시 클릭 시 닫기
        if (this.selectedHistory && this.selectedHistory.id === item.id) {
            this.selectedHistory = null;
            await this.service.render();
            return;
        }
        this.historyDetailLoading = true;
        this.selectedHistory = { id: item.id, loading: true };
        await this.service.render();
        try {
            const { code, data } = await wiz.call("get_calc_history", { id: item.id });
            if (code !== 200) {
                this.selectedHistory = null;
                await this.service.alert.error(data?.message || "불러올 수 없습니다.");
                return;
            }
            this.selectedHistory = data?.item || null;
        } finally {
            this.historyDetailLoading = false;
            await this.service.render();
        }
    }

    public async deleteCalcHistory(item: any, event?: any) {
        if (event) event.stopPropagation();
        if (this.historyDeletingId) return;
        const ok = await this.service.alert.show({
            title: '저장이력 삭제',
            message: `${item.title}\n해당 저장이력을 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.historyDeletingId = item.id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("delete_calc_history", { id: item.id });
            if (code !== 200) {
                await this.service.alert.error(data?.message || "삭제 실패");
                return;
            }
            if (this.selectedHistory && this.selectedHistory.id === item.id) {
                this.selectedHistory = null;
            }
            await this.loadCalcHistory();
        } finally {
            this.historyDeletingId = '';
            await this.service.render();
        }
    }

    public async downloadHistoryDocs(history: any) {
        if (!history || !history.snapshot || history.snapshot.length === 0) {
            await this.service.alert.error("다운로드할 항목이 없습니다.");
            return;
        }
        const files: { url: string; name: string }[] = [];
        const seen: any = {};
        for (let item of history.snapshot) {
            for (let f of (item.docs || [])) {
                if (!f || !f.url) continue;
                const label = this.deductionLabel(item, f);
                const ext = this.extractExt(f.name || f.url);
                files.push({ url: f.url, name: ext ? `${label}.${ext}` : (f.name || label) });
            }
            const fid = item.fund?.id;
            if (fid && !seen[fid]) {
                seen[fid] = true;
                for (let f of (item.incomeDocs || [])) {
                    if (!f || !f.url) continue;
                    files.push({ url: f.url, name: f.name || '소득공제서류' });
                }
            }
        }
        if (files.length === 0) {
            await this.service.alert.error("첨부된 서류가 없습니다.");
            return;
        }
        for (let f of files) {
            try {
                const resp = await fetch(f.url);
                const blob = await resp.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = f.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            } catch (e) { }
        }
    }

    public async downloadProcessedDocs() {
        if (this.downloadingDocs) return;
        if (!this.processedSnapshot || this.processedSnapshot.length === 0) {
            await this.service.alert.error("다운로드할 처리 항목이 없습니다.");
            return;
        }

        const files: { url: string; name: string }[] = [];
        const seenFundIncomeDocs: any = {};
        for (let item of this.processedSnapshot) {
            for (let f of (item.docs || [])) {
                if (!f || !f.url) continue;
                const label = this.deductionLabel(item, f);
                const ext = this.extractExt(f.name || f.url);
                const name = ext ? `${label}.${ext}` : (f.name || label);
                files.push({ url: f.url, name: name });
            }
            const fid = item.fund?.id;
            if (fid && !seenFundIncomeDocs[fid]) {
                seenFundIncomeDocs[fid] = true;
                for (let f of (item.incomeDocs || [])) {
                    if (!f || !f.url) continue;
                    files.push({ url: f.url, name: f.name || '소득공제서류' });
                }
            }
        }

        if (files.length === 0) {
            await this.service.alert.error("처리한 항목에 첨부된 소득공제 서류가 없습니다.");
            return;
        }

        this.downloadingDocs = true;
        await this.service.render();
        try {
            for (let f of files) {
                try {
                    const resp = await fetch(f.url);
                    const blob = await resp.blob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = f.name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                } catch (e) {
                    // 단일 파일 실패 시 다음 파일 계속 다운로드
                }
                await new Promise(r => setTimeout(r, 200));
            }
            await this.service.alert.success(`${files.length}건의 서류 다운로드를 시작했습니다.`);
        } catch (e) {
            await this.service.alert.error("다운로드 중 오류가 발생했습니다.");
        }
        this.downloadingDocs = false;
        await this.service.render();
    }

    private extractExt(filename: string): string {
        if (!filename) return '';
        const idx = filename.lastIndexOf('.');
        if (idx <= 0 || idx === filename.length - 1) return '';
        const ext = filename.substring(idx + 1);
        if (ext.includes('/') || ext.length > 8) return '';
        return ext;
    }

    public calcMarginalDeduction(prevCumulative: number, amount: number): number {
        if (amount <= 0) return 0;

        const T1 = 30000000;
        const T2 = 50000000;

        let deduction = 0;
        let remaining = amount;
        let cursor = prevCumulative;

        if (cursor < T1 && remaining > 0) {
            let portion = Math.min(remaining, T1 - cursor);
            deduction += portion;
            remaining -= portion;
            cursor += portion;
        }

        if (cursor < T2 && remaining > 0) {
            let portion = Math.min(remaining, T2 - cursor);
            deduction += Math.floor(portion * 0.7);
            remaining -= portion;
            cursor += portion;
        }

        if (remaining > 0) {
            deduction += Math.floor(remaining * 0.3);
        }

        return deduction;
    }
}

export default PortalLpsysMyprofileDeductionComponent;